import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { EobDuplicationEventProps } from '../../model'
import { EventNotes, FieldsGrid } from '../shared'

export function EobDuplicationEvent({
  event,
  searchQuery,
}: {
  event: EobDuplicationEventProps
  searchQuery: string
}) {
  return (
    <>
      <div className="flex flex-col gap-0.5 py-[3px]">
        <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
        {event.patients?.map((patient, index) => (
          <div
            key={index}
            className="mt-2"
          >
            <Text appearance="CAPTION">{`Patient ${patient.patientIndex}`}</Text>
            {patient.fields.length > 0 && (
              <FieldsGrid
                className="mt-1"
                fields={patient.fields}
                searchQuery={searchQuery}
                userRole={event.userRole}
              />
            )}
          </div>
        ))}
      </div>
      {event.notes && event.userRole === 'person' && (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      )}
    </>
  )
}
